import { SYNERGY_URL } from "../../constants";
import { apiSlice } from "../api-slice";
import { SynergyClip, SynergyResponse } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getEdits: build.query<SynergyResponse, { accessToken: string }>({
      query: ({ accessToken }) => ({ method: "GET", url: `${SYNERGY_URL}edits?take=5000`, accessToken }),
    }),
    getEditClips: build.query<SynergyClip[], { editId: string; clipCount: number }>({
      query: ({ editId, clipCount }) => ({
        method: "GET",
        url: `${SYNERGY_URL}edits/${editId}/clips?take=${clipCount}`,
      }),
      transformResponse: (response: SynergyClip[], meta, { editId }) =>
        response.map((clip) => ({
          ...clip,
          editId,
          result: clip?.eventData?.description ? clip?.eventData?.description?.split(">")[-1] || "N/A" : "N/A",
        })),
    }),
  }),
});

export const { useGetEditsQuery, useLazyGetEditsQuery, useGetEditClipsQuery, useLazyGetEditClipsQuery } =
  extendedApiSlice;
